// Step kinds and template rules — one wording for the template editor (/processtemplates,
// components/process-template/templateModel.js) and the process page (/eventannouncement,
// components/process/processUtils.js). Mirrors AveOrga.Shared.Contracts.Processes.

export const STEP_KIND_LABEL = {
  AssignLeaders: 'Spieltagleiter',
  Release: 'Freigabe',
  SendMail: 'Mail',
  ManualCheck: 'Manuelle Prüfung',
};

export const STEP_KIND_ICON = {
  AssignLeaders: 'sports',
  Release: 'visibility',
  SendMail: 'mail',
  ManualCheck: 'task_alt',
};

export const NEWSLETTER_TARGET_LABEL = 'Newsletter (Gäste & Interessenten)';

// Behavior rules of a template (same flags on ProcessTemplateResponse and EventProcessResponse).
// `badge` = short card/chip label (null = no badge); array order = badge order.
export const TEMPLATE_RULES = [
  {
    key: 'neverPublic', label: 'Nie öffentlich', badge: 'Nie öffentlich', icon: 'visibility_off',
    hint: 'Keine Freigabe für Gäste und kein Newsletter – die Events erscheinen nie auf der Homepage.',
  },
  {
    key: 'linkSignup', label: 'Einladungslink', badge: 'Einladungslink', icon: 'link',
    hint: 'Jedes Event bekommt einen geheimen Einladungslink, über den sich Gäste anmelden.',
  },
  {
    key: 'prepaymentRequired', label: 'Vorkasse', badge: 'Vorkasse', icon: 'payments',
    hint: 'Zahlungspflichtige Bestätigte bekommen statt der Bestätigung eine Zahlungsaufforderung.',
  },
  {
    key: 'requiresLeader', label: 'Spieltagleitung nötig', badge: 'Leitung nötig', icon: 'sports',
    hint: 'Events bleiben im Entwurf, bis eine Spieltagleitung eingetragen ist.',
  },
  {
    key: 'autoPaidOnPresenceDefault', label: 'Bezahlt bei Anwesenheit', badge: null, icon: 'price_check',
    hint: 'Voreinstellung für neue Events: Der Check-in markiert Zahlungspflichtige automatisch als bezahlt (je Event änderbar).',
  },
];
